<template>
    <app-layout title="Create Survey">
        <template v-slot:header>
            <h2 class="font-semibold text-xl text-gray-800 dark:text-gray-200 leading-tight">
                Finalize Survey Order
            </h2>
        </template>

        <div>
            <survey-price-calculator :survey-model="surveyModel"
                                     :unit-prices="unitPrices"
                                     :order="order"
            />
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import SurveyPriceCalculator from "@/Components/SurveyPriceCalculator";

export default {
    components: {
        SurveyPriceCalculator,
        AppLayout,
    },
    props: {
        surveyModel: Object,
        unitPrices: Array,
        order: Object,
    },
}
</script>
